<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import Information from '@components/information'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
	page: {
		title: 'Log in',
		meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
	},
	components: { Layout, Information },
	data() {
		return {
			username: '',
			password: '',
			customerEmail: '',
			listUrl: '',
			authError: null,
			tryingToLogIn: false,
			isAuthError: false,
			showInformation: false,
			informationText: '',
		}
	},
	methods: {
		...authMethods,
		tryToLogIn() {
			this.tryingToLogIn = true;
			this.authError = null;
			if (this.customerEmail == '' && this.listUrl == '') {
				this.informationText = 'É necessário preencher ou o Email do cliente ou a Url da lista';
				this.showInformation = true;
				return;
			} 
			else if (this.customerEmail.length > 0 && this.listUrl.length > 0) {
				this.informationText = 'Preencha ou o Email do cliente ou a Url da lista';
				this.showInformation = true;
				return;
			}
			else if (this.listUrl.length > 0 && (this.listUrl.indexOf('http') != -1 || this.listUrl.indexOf('.com') != -1) ) {
				this.informationText = 'Preencha apenas a url da lista. Ex: "luciana-e-julio"';
				this.showInformation = true;
				return;
			}
			return this.personateCustomerLogIn({
				username: this.username,
				password: this.password,
				customerEmail: this.customerEmail,
				listUrl: this.listUrl
			})
				.then((token) => {
					this.tryingToLogIn = false
					this.isAuthError = false
					this.$router.push({ path: '/minhaslistas' })
				})
				.catch((error) => {
					this.tryingToLogIn = false
					this.authError = error.response ? error.response.data.message : ''
					this.isAuthError = true
				})
		},
	},
}
</script>

<template>
	<Layout>
		<!-- end row -->
		<div class="account-pages my-5">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-xl-6">
						<div class="card">
							<div class="card-body p-0">
								<div class="row">
									<div class="col-md-12 p-5">
										<div class="mx-auto mb-5">
											<a routerLink="/">
												<img src="@assets/images/logo.png" alt height="24" />
												<h3 class="d-inline align-middle ml-1 text-logo">Giftcredit</h3>
											</a>
										</div>

										<b-alert v-model="isAuthError" variant="danger" dismissible>{{ authError }}</b-alert>

										<b-form class="authentication-form" @submit.prevent="tryToLogIn">

											<div class="form-group">
												<div class="input-group input-group-merge">

													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="mail" class="align-middle icon-dual"></feather>
														</span>
													</div>

													<b-form-input v-model="customerEmail" type="text" placeholder="Email do cliente"></b-form-input>
												</div>
											</div>

											<div class="form-group">
												<div class="input-group input-group-merge">

													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="link" class="align-middle icon-dual"></feather>
														</span>
													</div>

													<b-form-input v-model="listUrl" type="text" placeholder="Url da lista"></b-form-input>
												</div>
											</div>

											<div class="form-group">
												<div class="input-group input-group-merge">

													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="mail" class="align-middle icon-dual"></feather>
														</span>
													</div>

													<b-form-input id="input-1" v-model="username" type="text" required placeholder="Usuário"></b-form-input>
												</div>
											</div>

											<div class="form-group mt-4">
												<div class="input-group input-group-merge">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather
																type="lock"
																class="align-middle icon-dual"
															></feather>
														</span>
													</div>
													<b-form-input
														id="password"
														v-model="password"
														type="password"
														required
														placeholder="Senha"
													></b-form-input>
												</div>
											</div>


											<b-form-group id="button-group" class="mt-4 mb-1">
												<b-button
													type="submit"
													variant="primary"
													class="btn-block"
													>Log In</b-button
												>
											</b-form-group>
										</b-form>

									</div>
								</div>
							</div>
							<!-- end card-body -->
						</div>
						<!-- end card -->

					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</div>

		<information :informationtext="informationText" :showDialog="showInformation" @ok="showInformation=false" />

	</Layout>
</template>

<style lang="scss" module></style>
